import { render, staticRenderFns } from "./addScheduleClassesStaff.vue?vue&type=template&id=3924948b&scoped=true"
import script from "./addScheduleClassesStaff.vue?vue&type=script&lang=js"
export * from "./addScheduleClassesStaff.vue?vue&type=script&lang=js"
import style0 from "./addScheduleClassesStaff.vue?vue&type=style&index=0&id=3924948b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3924948b",
  null
  
)

export default component.exports